exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.2rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  text-indent: 0.21rem;\n  margin: 0.01rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n  margin: 0.1rem 0rem;\n}\n#privacy div .sub-title {\n  font-weight: 500;\n  margin-top: 0.08rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-3583a9f1","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/module/checklist/checklist.vue
// module id = 357
// module chunks = 23